export default class AuthState {
  currentUser: object | null = null;
}
